// removed by extract-text-webpack-plugin
module.exports = {"contentLeftMenu":"_1YetW3LtpGwi75C69KFUI4","contentLeftMenuBlack":"_1V9AXDO-zXIreSDlK7zvPV","contentleftMenuScroll":"_110ZMHOPoYWPmPMtzbG3kv","scrollTopSearch":"_11K5VRrY1TEUhDMl62wRDS","searchBox":"_2_e2UE_MQrfVDSaPX8aDbp","searchInput":"eB94BCKPoiLTFPeyebOwX","scrollContext":"_1zBPa4uuI2P2bkOMyuG9Iw","scrollContextUl":"_2dPHHGpZdur4-qgCfQeRjJ","back1":"_3yJ2nSlrExH5l1Rhmic6C8","back2":"_2-XKhE8Unl_dhik4oB4aom","back3":"DDeNY8UmqQ8dzdOBpsDUW","scrollContextDiv":"_2Y4fDowRD0P-wD1cC3Mmxj","scrollContextDd":"bgqN3BVkEI-AaG6ofQdXE","dlBack":"_25ke8CWCv6Z61P3lWxYvKX"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/NewSearchPageComponent/NewSearchPageComponent.scss
 ** module id = 1001
 ** module chunks = 0
 **/